import axios from "axios";

export interface SearchableProduct {
  title: string;
  thumb: string;
  text: string;
  tags: string;
  loc: string;
  categoryLoc: string;
  isOTC: boolean;
}

export function getSearchableProducts(): Promise<SearchableProduct[]> {
  return axios.get("/resources/static/product_list.json").then((response) => response.data);
}
